import reduxSignalRMiddleware, { withCallbacks } from "_shared/_stores/realtime/redux-signalr-middleware";
import Guid from "_shared/guids/guid";
import { MessageJSON } from "messaging/_schemas/message-schema";
import { messageHubConnection } from "messaging/_stores/_realtime/messages-signalr-redux-middleware";
import Message from "messaging/message";
import { Action } from "notifications/values/action/action";
import TopicCategory from "notifications/values/topic-category/topic-category";
import { addComment, removeCommentById } from "work/proposals/comments/_store/comments-redux-slice";
import Comment from "work/proposals/comments/comment";
import { addCommentThread } from "work/proposals/comments/threads/_store/comment-thread-redux-slice";

function toMessage(payload: unknown): Message {
  return Message.fromJSON({
    json: payload as MessageJSON,
  });
}
const callbacks = withCallbacks()
  .add("message-received", (payload: unknown) => (dispatch) => {
    const message = toMessage(payload);
    if (
      message.forum.topic?.entityClass?.value.toLowerCase() === TopicCategory.Work.Proposal.toLowerCase() &&
      message.forum.topic.context?.toLowerCase().includes(Action.Review.toLowerCase())
    ) {
      const comment = Comment.fromMessage(message);
      dispatch(addComment(comment));
      dispatch(addCommentThread(comment.thread));
    }
  })
  .add("message-updated", (payload: unknown) => (dispatch) => {
    const message = toMessage(payload);
    if (
      !(
        message.forum.topic?.entityClass?.value.toLowerCase() === TopicCategory.Work.Proposal.toLowerCase() &&
        message.forum.topic.context?.toLowerCase().includes(Action.Review.toLowerCase())
      )
    ) {
      return;
    }
    const comment = Comment.fromMessage(message);
    dispatch(addComment(comment));
    dispatch(addCommentThread(comment.thread));
  })
  .add("message-deleted", (payload: unknown) => (dispatch) => {
    const deletedCommentId = new Guid((payload as { id: string }).id);
    dispatch(removeCommentById(deletedCommentId));
  });

export const commentsSignalRReduxMiddleware = reduxSignalRMiddleware({
  callbacks,
  connection: messageHubConnection,
  shouldConnectionStartImmediately: true,
});
